// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sace","importantInfo":"styles_importantInfo__38U0U"};